import { gql } from "@apollo/client";
export const portOfDataQry = gql`
{
    portOfLoadings{
        id
        value
        country
        trackingCode
    }
    portOfDestinations{
        id
        value
        country
        trackingCode
    }
    placesOfDelivery{
        id
        value
        country
    }
    incoterms{
        id
        value
    }
}
`;

